var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 11
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-1-1h15v13H-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2E5FCA",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10.564 3.697Q6.766 7.192 6.49 7.191T2.3 3.698"
})));
export default SvgDown;